import { render, staticRenderFns } from "./newsdetal.vue?vue&type=template&id=2e455e92&scoped=true"
import script from "./newsdetal.vue?vue&type=script&lang=js"
export * from "./newsdetal.vue?vue&type=script&lang=js"
import style0 from "./newsdetal.vue?vue&type=style&index=0&id=2e455e92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e455e92",
  null
  
)

export default component.exports